// import { forwardRef } from 'react'
// import { PatternFormat, PatternFormatProps } from 'react-number-format'
import { PatternFormat, PatternFormatProps } from 'react-number-format'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import { ReadonlyTextField } from 'text_field'

type CustomFormatProps = Omit<TextFieldProps, 'defaultValue' | 'type'> & Omit<PatternFormatProps, 'format' | 'size'>

export const TextInputPhone = (props: CustomFormatProps) => {
  const { onChange, ...others } = props

  if (props.readOnly) {
    return <ReadonlyTextField sx={props.sx} label={props.label} value={props.value as string} />
  }

  return (
    <PatternFormat
      {...others}
      value={props.value as string}
      format="(###) ###-####"
      type="text"
      customInput={TextField}
      onValueChange={({ value }) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        onChange?.({ target: { name: props.name || '', value } })
      }}
      valueIsNumericString
    />
  )
}
